module.exports = __webpack_public_path__ + "img/w_bigbanner1.1fce48e1.jpg";